import React from 'react';
import { TreinamentoStatus } from '../shared/atlasApi';

const MAPA: Record<string, { label: string; classes: string }> = {
  rascunho: { label: 'Rascunho', classes: 'bg-gray-100 text-gray-600' },
  publicado: { label: 'Publicado', classes: 'bg-emerald-100 text-emerald-700' },
  encerrado: { label: 'Encerrado', classes: 'bg-rose-100 text-rose-700' },
};

const BadgeStatusT: React.FC<{ status?: TreinamentoStatus | string }> = ({ status }) => {
  const m = MAPA[status || ''] || { label: status || '—', classes: 'bg-gray-100 text-gray-500' };
  return <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${m.classes}`}>{m.label}</span>;
};

export default BadgeStatusT;
